jQuery(document).ready(function(){
jQuery('.tabs-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   dots: false,
   focusOnSelect: true,
    infinite: false,
    speed: 500,
  arrows:false
 });
 jQuery('.tab-single[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   jQuery('.tabs-slider').slick('slickGoTo', slideno - 1);
   console.log(slideno);
 });
  jQuery('.tab-single:first-child').addClass('tab-active');
  jQuery('.tab-single').on('click', function(){
      jQuery('.tab-single').removeClass('tab-active');
      jQuery(this).addClass('tab-active');
    
    // jQuery('.tab-single').removeClass('tab-active');
  });

  $(".tabs-slider").find('.slick-current').next().find('.item-text').css({"transform": "translateX(100%)", "transition":"none"});
    $(".tabs-slider").find('.slick-current').prev().find('.item-text').css({"transform": "translateX(-100%)", "transition":"none"});
  $('.tabs-slider').on('afterChange', function(event, slick, currentSlide, nextSlide, prevSlide){
    $(".tabs-slider").find('.slick-slide').removeClass("right-slide");
    $(".tabs-slider").find('.slick-slide').removeClass("left-slide");
    $(".tabs-slider").find('.slick-current').next().find('.item-text').css({"transform": "translateX(100%)", "transition":"none"});
    $(".tabs-slider").find('.slick-current').prev().find('.item-text').css({"transform": "translateX(-100%)", "transition":"none"});
    
    $('.tab-single').each(function(){
      var slideno = $(this).data('slide');
      var currentIndex = $('.tabs-slider .slick-current').index() + 1;
      if(slideno == currentIndex){
        jQuery('.tab-single').removeClass('tab-active');
        jQuery(this).addClass('tab-active');
      }
    })
    
  });
});